import { render, staticRenderFns } from "./BottomMene.vue?vue&type=template&id=2fe054a2"
import script from "./BottomMene.vue?vue&type=script&lang=js"
export * from "./BottomMene.vue?vue&type=script&lang=js"
import style0 from "./BottomMene.vue?vue&type=style&index=0&id=2fe054a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports